module.exports = __webpack_public_path__ + "img/products.690176f5.png";